import {request} from "../../request";

export const SegmentRequests = {
  runSegment: async (segmentId) => {
    return request("segments/run/" + segmentId, "POST", {});
  },
};
